module.exports = __webpack_public_path__ + "static/income.c34fef88.png";